import { ref, computed, watch, onMounted } from 'vue'

export function useBranchManager (getBranchData, localKey = 'branch_id') {
  const { BranchDataList } = getBranchData()
  const branchUsed = ref([])
  const selectedBranchId = ref('')

  const branchList = computed(() => {
    return BranchDataList.value.filter((item) =>
      branchUsed.value.includes(item.id)
    )
  })

  const selectedBranch = computed(() =>
    BranchDataList.value.find((item) => item.branch_id === selectedBranchId.value)
  )

  // Initialize only IDs
  onMounted(() => {
    const localBranch = localStorage.getItem('branch')
    if (localBranch) {
      branchUsed.value = localBranch.split(',')
      const savedId = localStorage.getItem(localKey)
      selectedBranchId.value = savedId || branchUsed.value[0]
    }
  })

  // Wait for both data and ID to be valid
  watch(
    [BranchDataList, selectedBranchId],
    ([list, branchId]) => {
      const branch = list.find((item) => item.branch_id === branchId)
      if (branch) {
        // console.log('Branch ready from watch', branch)
        localStorage.setItem('lang_source', branch.first_language || 'id')
        localStorage.setItem('lang_target', branch.second_language || 'en')
      }
    },
    { immediate: true }
  )

  // Keep localStorage in sync
  watch(selectedBranchId, (newVal) => {
    localStorage.setItem(localKey, newVal)
  })

  return {
    selectedBranchId,
    branchList,
    BranchDataList,
    selectedBranch
  }
}
